import { SESSION_STORAGE_APP_STATE_KEY } from 'config/consts';
import { getEntryModeFromWindow, isExistingSiteEntryMode } from 'config/entry-mode';
import { windowUtils } from './window';
import { AppState } from 'stores/appStore';
import { CategoryKey } from 'config/categories';
import { productParamsById, productsByCategory } from 'config/products';
import { normalizeSelectedProducts } from 'utils/product-selection';

const setAppState = (state: AppState) => {
  windowUtils.getSafeWindow()?.sessionStorage.setItem(SESSION_STORAGE_APP_STATE_KEY, JSON.stringify(state));
};

const getInitialAppState = (): AppState => {
  const window = windowUtils.getSafeWindow();
  const appStateString = window?.sessionStorage.getItem(SESSION_STORAGE_APP_STATE_KEY);
  const entryMode = getEntryModeFromWindow();
  const selectedCategory = CategoryKey.BestSellers;
  const [firstProductId] = productsByCategory[selectedCategory];
  const defaultFirstProduct = { id: firstProductId, ...productParamsById[firstProductId] };

  const defaultState: Omit<AppState, 'metaSiteId' | 'entryMode'> = {
    selectedProducts: isExistingSiteEntryMode(entryMode) ? [] : [defaultFirstProduct],
    currentStep: undefined,
    localFile: undefined,
    storeName: undefined,
    mediaUrl: undefined,
    siteUrl: undefined,
    selectedCategory,
    wasStoresInstalledAtEntry: undefined,
  };

  const storedState: Partial<AppState> = appStateString ? JSON.parse(appStateString) : {};
  const metaSiteId = window?.__META_SITE_ID__;
  const canRestoreSession = storedState.metaSiteId === metaSiteId && storedState.entryMode === entryMode;

  const restoredState = canRestoreSession ? storedState : {};

  return {
    ...defaultState,
    ...restoredState,
    selectedProducts: canRestoreSession
      ? normalizeSelectedProducts(restoredState.selectedProducts)
      : defaultState.selectedProducts,
    entryMode,
    metaSiteId,
  };
};

export const sessionStorageUtils = {
  setAppState,
  getInitialAppState,
};
